exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".header-wrapper .top-notification {\n  background-color: #fbf1d5;\n  margin-bottom: unset;\n  height: 30px;\n  text-align: center;\n  padding-top: 4px;\n}\n", ""]);
